import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { DatepickerContainerComponent } from './datepicker-container/datepicker-container.component';
import { DateSelectComponent } from './date-select/date-select.component';
import { YearSelectComponent } from './year-select/year-select.component';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';
import { TextInputModule } from '../text-input/text-input.module';
import { IconModule } from '../../icon/icon.module';

@NgModule({
  declarations: [
    DatepickerComponent,
    DatepickerContainerComponent,
    DateSelectComponent,
    YearSelectComponent,
  ],
  imports: [
    TextInputModule,
    CommonModule,
    FormsModule,
    IconModule,
    TranslocoModule,
  ],
  exports: [DatepickerComponent],
})
export class DatepickerModule {}
